export default {
  url: "https://104.238.215.112",
  //url: "http://localhost:34523",
};
